import type { Entregador } from "../../../services/entregadores"

export enum EntregadoresActionsTypes {
    CARREGAR = "CARREGAR",
}

export type EntregadoresActions = {
    type: EntregadoresActionsTypes.CARREGAR
    payload: Entregador[]
}
